import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["precision", "children"];
import * as React from 'react';
import useTranslator from './useTranslator';
/**
 * This component is just syntaxic sugar around the `formatNumber` function. Use `formatNumber` directly if possible.
 */
export default function FormatNumber(props) {
  var precision = props.precision,
    children = props.children,
    extraProps = _objectWithoutProperties(props, _excluded);
  var _useTranslator = useTranslator(),
    formatNumber = _useTranslator.formatNumber;
  return /*#__PURE__*/React.createElement("span", extraProps, formatNumber(children, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  }));
}